<template>
  <div class="hm-card" :class="($template === 'article') ? 'article' : 'small'">
    <div class="max-w">
      <h2>Do You Receive Extra Help?</h2>
      <p>
        If you and/or your spouse already receive Extra Help (LIS – Low Income Subsidy), select “Yes.”
        <span class="tooltip-icon" v-tooltip="'Extra Help (or Low Income Subsidy) is a government program that helps beneficiaries with limited financial resources lower their prescription drug costs.'">
          <img src="//hm-lis.herokuapp.com/img/svg/info-circle-solid.svg" alt="image">
        </span>
      </p>
    </div>

    <SuiDivider inverted v-if="($template === 'small')"/>
    
    <div class="max-w">
      <div
        class="center"
        :class="($template === 'article') ? 'large-icons-block' : ''">
          <SuiButton
            basic
            color="grey"
            class="large-icon full-width"
            @mouseover="checkOn = 'check_on_green'"
            @mouseleave="checkOn = 'check_on'"
            :class="{ 'article': ($template === 'article') }"
            @click="() => onReceiveExtraHelp(true)">
            <img :src="`//hm-lis.herokuapp.com/img/svg/${checkOn}.svg`" alt="image" class="large-icon">
            <span>Yes</span>
          </SuiButton>
          <SuiButton
            basic
            color="grey"
            class="large-icon full-width"
            @mouseover="checkOff = 'check_off_green'"
            @mouseleave="checkOff = 'check_off'"
            :class="{ 'article': ($template === 'article') }"
            @click="() => onReceiveExtraHelp(false)">
            <img :src="`//hm-lis.herokuapp.com/img/svg/${checkOff}.svg`" alt="image" class="large-icon">
            <span>No</span>
          </SuiButton>
      </div> 

      <div>
        <div class="dropdown" v-if="receiveExtraHelp">
          <p>How Much Help Do You Receive</p>
          <SuiDropdown
            placeholder="Select One"
            selection
            fluid
            :labeled="true"
            :options="howMuchOptions"
            v-model="howMuch"
          />
        </div>
      </div>

      <SuiButton v-if="receiveExtraHelp" color="green" :class="{ 'article': ($template === 'article') }" :disabled="isNextDisabled()" @click="() => goNextStep('bank-and-investment')">Next</SuiButton>

    </div>
  </div>
</template>

<script>
  import {Button} from 'semantic-ui-vue/dist/commonjs/elements/Button';
  import {Dropdown} from 'semantic-ui-vue/dist/commonjs/modules/Dropdown';
  import {Divider} from 'semantic-ui-vue/dist/commonjs/elements/Divider';

  export default {
    name: 'ExtraHelp',
    components: {
      SuiButton: Button,
      SuiDropdown: Dropdown,
      SuiDivider: Divider,
    },
    data() {
      return {
        checkOn: 'check_on',
        checkOff: 'check_off',
        receiveExtraHelp: false,
        howMuch: null,
        howMuchOptions: [
          {
            text: 'I pay $1.25 - $3.80 for covered drugs.',
            value: 3,
          },
          {
            text: 'I pay $3.40 - $8.50 for covered drugs.',
            value: 2,
          },
          {
            text: 'I\'m Not Sure',
            value: 1,
          },
        ],
        amount: null,
        amountOptions: [
          {
            text: '0%',
            value: 0,
          },
          {
            text: '25%',
            value: 25,
          },
          {
            text: '50%',
            value: 50,
          },
          {
            text: '75%',
            value: 75,
          },
          {
            text: `I don't know`,
            value: -1,
          },
        ],
      };
    },
    methods: {
      isNextDisabled() {
        return (
          this.$data.receiveExtraHelp && !this.$data.howMuch
        )
      },
      onReceiveExtraHelp(value) {
        this.$data.receiveExtraHelp = value;

        if (value === false) {
          this.goNextStep('bank-and-investment');
        }
      },
      goNextStep(step) {
        this.$store.commit('setExtraHelp', {
          howMuch: this.$data.howMuch,
          amount: this.$data.amount,
        });
        this.$store.commit('setStep', step);
        if (this.$template == 'landing') {
          window.scrollTo(0,0);
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

  .large-icon-square:hover {
    .check-off {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_off_green.svg');
    }
    .check-on {
      background-image: url('//hm-lis.herokuapp.com/img/svg/check_on_green.svg');
    }
  }
  .check-on {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_on.svg');
  }
  .check-off {
    background-image: url('//hm-lis.herokuapp.com/img/svg/check_off.svg');
  }

</style>

